<template>
<div>
  <ui-toolbar type="colored" text-color="white" :loading="loading" :preloader-top="preloaderTop" :remove-nav-icon="hideNavIcon" @nav-icon-click="navIconClick" :flat="true" :show-brand="showBrand">
    <div slot="brand">
      <a @click.prevent="$router.push({ name: 'admin.home'})">{{ title }}</a>
    </div>
    <div slot="actions">
      <div class="toolbar-menu">
        <ui-button type="clear" @click="$router.push({name: 'admin.messages.dashboard'})">Wiadomości</ui-button>
        <ui-button type="clear" @click="$router.push({name: 'admin.emails.dashboard'})">Subskrybenci</ui-button>
      </div>
    </div>
  </ui-toolbar>

  <div class="grid grid-full grid-pad">
    <div class="col-2-12" v-if="menuLeft">
      <left-menu :items="leftMenuItems"></left-menu>
    </div>
    <div :class="[
    menuLeft ? 'col-10-12' : 'col-1-1'
    ]">
      <div class="admin-content">
        <router-view></router-view>
        <ui-confirm type="primary"
        :confirm-button-text="confirm.confirmButton"
        :deny-button-text="confirm.denyButton"
        @confirm="confirmed"
        @deny="denied"
        ref="confirm1"
        autofocus="confirm-button"
        :close-on-confirm="true"
        :backdrop-dismissible="true"
        :title="confirm.confirm">
          {{ confirm.message }}
        </ui-confirm>
    </div>
  </div>
  </div>
  <ui-snackbar-container
  ref="snackbarContainer"
  :position="position"
  :allow-html="allowHtml"
  :queue-snackbars="queueSnackbars">
  </ui-snackbar-container>

</div>

</template>
<script>
import Utils from './../../services/Utils'
import EventEmitter from './../../services/EventEmitter'
import { newslettersMenu, emailsMenu, adminMenu, myMenu } from './index'
import LeftMenu from './LeftMenu.vue'
export default {
  components: {LeftMenu},
  data () {
    return {
      preloaderTop: true,
      loading: false,
      showBrand: true,
      flat: true,
      hideNavIcon: false,
      menuLeft: true,
      title: 'Adm-newsletter',
      user: {
        email: null,
        id: null
      },
      leftMenuItems: [
        {header: 'Wiadomości e-mail', items: newslettersMenu},
        {header: 'Subskrybenci', items: emailsMenu},
        {header: 'Administracja', items: adminMenu},
        {header: 'Twój profil', items: myMenu}
      ],
      position: 'right',
      queueSnackbars: true,
      allowHtml: true,
      action: '',
      duration: 5,
      actionColor: 'accent',
      message: '',
      baseConfirmTitle: 'Napewno?',
      confirm: {
        show: false,
        confirm: 'Napewno?',
        message: 'Jesteś pewien? Ta operacja jest nieodwracalna',
        confirmButton: 'Usuń',
        denyButton: 'Anuluj',
        confirmCb: () => {},
        denyCb: () => {}
      }
    }
  },
  methods: {
    toggle: function () {
      this.loading = !this.loading
    },
    selectMenuItem (e) {
      this.$router.push({
        name: e.route,
        params: {}
      })
    },
    setLoading (val) {
      this.loading = !!val
    },
    confirmed () {
      if (Utils.isFunction(this.confirm.confirmCb)) {
        this.confirm.confirmCb(true)
      }
      this.show = false
    },
    navIconClick () {
      this.menuLeft = !this.menuLeft
    },
    denied () {
      if (Utils.isFunction(this.confirm.denyCb)) {
        this.confirm.denyCb(false)
      }
    },
    notify (msg) {
      this.$refs.snackbarContainer.createSnackbar({
        message: msg,
        action: null,
        actionColor: this.actionColor,
        duration: this.duration * 1000
      })
    }
  },
  mounted () {
    EventEmitter.$on('user.get', user => {
      this.user = user
    })
    EventEmitter.$on('admin.loading', val => {
      this.setLoading(val)
    })
    EventEmitter.$on('confirm.show', e => {
      this.confirm.confirmCb = e.confirmCb ? e.confirmCb : () => {}
      this.confirm.denyCb = e.denyCb ? e.denyCb : () => {}
      this.confirm.show = true
      this.confirm.title = e.title || this.baseConfirmTitle
      this.$refs.confirm1.open()
    })
    EventEmitter.$on('admin.notify', this.notify)
    // TODO nie ma error toast w keen ui
    EventEmitter.$on('admin.notify-error', this.notify)
  }
}
</script>


// WEBPACK FOOTER //
// Layout.vue?ede27098